import Breadcrumb from '../components/Breadcrumb'
import { Helmet } from 'react-helmet'
import Mail from '../components/Mail'
import { initialize } from '../store/pagedata'
import { useDispatch } from 'react-redux'
import { useEffect } from 'react'

const BugReport = () => {
  const destination = 'bugreport@edhrec.com'
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(initialize())
  }, [])

  return (
    <>
      <Helmet>
        <meta name='description' content='Report a bug to the EDHREC team' />
        <meta name='keywords' content='EDHREC,bug,error,issue,report' />
        <title>Bug Report | EDHREC</title>
      </Helmet>
      <Breadcrumb breadcrumb={[{ '/bug-report': 'Bug Report' }]} />
      <h1 className='page-heading'>Report a Bug</h1>
      <Mail
        description={
          <p>
            {'Use the form below, or email us at '}
            <a href={`mailto:${destination}`} rel='noreferrer' target='_blank'>
              {destination}
            </a>
            .
          </p>
        }
        destination={destination}
      />
    </>
  )
}

export default BugReport
